import { render, staticRenderFns } from "./post.vue?vue&type=template&id=cabae7ba&"
import script from "./post.vue?vue&type=script&lang=js&"
export * from "./post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports